module.exports = __webpack_public_path__ + "img/manufacturing-blue.82311611.png";